import React, { useState, useEffect } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { fetchAddress, fetchUtility } from './fetch/api';
import { Dropdown } from 'react-bootstrap';

export const ValidateAddress = (props:{
    handleSave:Function;
}) => {
    const [ loading, setLoading ] = useState(false);
    const [ addressOptions, setAddressOptions ] = useState<any[]>([]);
    const [ selectedAddress, setSelectedAddress ] = useState<any[]>([]);
    const [ utility, setUtility ] = useState<any[]>([]);
    const [ selectedUtility, setSelectedUtility ] = useState<any | undefined>(undefined);
    const {handleSave} = props;

    useEffect(() => {
        if (selectedAddress.length === 0) return;
        const { zipcode , premise_type} = selectedAddress[0];
            fetchUtility(zipcode).then(res => {
                if (res) {
                    setUtility(res);
                    setSelectedUtility(res[0]);
                }
            })

    }, [selectedAddress])

    useEffect(()=>{
        if (selectedAddress.length> 0 && selectedUtility) {
            const o = {address: selectedAddress[0], utility: selectedUtility};
            handleSave(o);
        }
        
    },[selectedAddress, selectedUtility])

    const handleSearch = (val:string) => {
        setLoading(true);
        setSelectedAddress([]);
        setSelectedUtility(undefined)
        handleSave(undefined);
        fetchAddress(val).then(data => {
            setAddressOptions(data);
            setLoading(false);
        })
    }

    return (
        <div className='autocomplete-section'>
            <p>Enter your address</p>
            <div className="autocomplete-address-row">
                <div id="autocomplete-wrapper">
                    <AsyncTypeahead
                        filterBy={() => true}
                        id="autocomplete"
                        isLoading={loading}
                        labelKey="label"
                        minLength={1}
                        onSearch={handleSearch}
                        options={addressOptions}
                        placeholder={`${('Address')}...`}
                        size="lg"
                        onChange={setSelectedAddress}
                        selected={selectedAddress}
                    />
                </div>
            </div>
        </div>
    )
}